import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_SCA_LABEL,
  EVENTS_AWARDS_SCA_PATH,
} from "@events-awards/utils/constants";
import {
  AwardType,
  EventsAwardsHomePageContextData,
} from "@events-awards/utils/types";
import SCAArticle from "@sca/components/SCAArticle";
import SCADescription from "@sca/components/SCADescription";
import SCAFooter from "@sca/components/SCAFooterComponents/SCAFooter";
import SCANominationsDescription from "@sca/components/SCANominationsDescription";
import SCAOrganiserDetails from "@sca/components/SCAOrganiserDetails";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * Component to render SCA page
 */
const EventsAwardsSCAPageContent = ({
  articleProps,
}: EventsAwardsHomePageContextData): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  return (
    <div
      className="w-full"
      data-testid="events-awards-sca-page-content-component"
    >
      <AdSettings
        adNames={["lb1", "prestitial", "catfish"]}
        path={EVENTS_AWARDS_SCA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Singapore Corporate Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title="Singapore Corporate Awards Latest News & Headlines - THE BUSINESS TIMES"
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_SCA_LABEL} - Find ${EVENTS_AWARDS_SCA_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_SCA_PATH}
      />

      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.SCA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <SCAArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <SCADescription />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <SCANominationsDescription />
        </Container>
      </div>

      <SCAOrganiserDetails />

      <SCAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsSCAPageContent;
